"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Table2_1 = require("../Table2");
const DataTable = ({ rows, columns, selectable, onRowClick, onRowDoubleClick, hideHeader, compact }) => {
    const [selectedRows, setSelectedRows] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        setSelectedRows([]);
    }, [rows]);
    const handleRowClick = (row, index) => (event) => {
        if (onRowClick)
            onRowClick(row, index, event);
        if (selectable) {
            setSelectedRows([index]);
        }
    };
    const handleRowDoubleClick = (row, index) => (event) => {
        if (onRowDoubleClick)
            onRowDoubleClick(row, index, event);
        if (selectable) {
            setSelectedRows([index]);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Table2_1.Table2, { children: [!hideHeader && ((0, jsx_runtime_1.jsx)(Table2_1.TableHead, { children: (0, jsx_runtime_1.jsx)(Table2_1.TableRow, { children: columns.map((col, colIndex) => {
                        return ((0, jsx_runtime_1.jsx)(Table2_1.TableCell, { children: col.header && col.header() }, colIndex));
                    }) }, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(Table2_1.TableBody, { children: rows.map((row, rowIndex) => {
                    const isSelected = selectedRows.some(selectedIndex => selectedIndex === rowIndex);
                    return ((0, jsx_runtime_1.jsx)(Table2_1.TableRow, Object.assign({ selected: isSelected }, { children: columns.map((col, colIndex) => ((0, jsx_runtime_1.jsx)(Table2_1.TableCell, Object.assign({ onClick: handleRowClick(row, rowIndex), onDoubleClick: handleRowDoubleClick(row, rowIndex) }, { children: col.cell && col.cell(row, isSelected) }), colIndex))) }), rowIndex));
                }) }, void 0)] }, void 0));
};
exports.DataTable = DataTable;
//# sourceMappingURL=DataTable.js.map